<template>
	<div class="yhStoreManageAdd">
		<el-card>
			<!-- 返回列表页面 -->
			<div class="jump-btn">
				<el-button type="primary" @click="back()">返回商户列表</el-button>
			</div>
			<el-form :model="form" :rules="rules" ref="form" :label-width="require('@/config/enum').c_w6"
				:label-suffix="require('@/config/enum').c_colon">
        <!-- 所在项目 -->
        <el-form-item label="所在项目" prop="gardenId">
          <el-select v-model="form.gardenId" class="selGard" disabled="disabled">
						<el-option v-for="(item,index) in gardenList" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
        <!-- 所在楼层 -->
        <el-form-item label="所在楼层" prop="houseId">
          <el-select v-model="form.houseId" placeholder="请选择商户所在楼层" class="selGard">
						<el-option v-for="(item,index) in houseList" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<!-- 商户名称 -->
				<el-form-item label="商户名称" prop="shopName">
					<el-input v-model="form.shopName"
						placeholder="请输入商户名称" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 商户编号 -->
				<el-form-item label="商户编号" prop="shopNo">
					<el-input v-model="form.shopNo"
						placeholder="请输入商户编号" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 商户分类 -->
				<el-form-item label="商户分类" prop="shopType1">
					<el-select v-model="form.shopType1" placeholder="请选择商户分类" class="selGard">
						<el-option v-for="(item,index) in shopType1List" :key="index" :label="item.name" :value="item.name"></el-option>
					</el-select>
				</el-form-item>
				<!-- 商户电话 -->
				<el-form-item label="商户电话" prop="shopPhone">
					<el-input v-model="form.shopPhone"
						placeholder="请输入商户电话" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>			
        <!-- 商户经度 -->
				<el-form-item label="商户经度" prop="shopX">
					<el-input v-model="form.shopX"
						placeholder="请输入商户经度" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>		
        <!-- 商户纬度 -->
				<el-form-item label="商户纬度" prop="shopY">
					<el-input v-model="form.shopY"
						placeholder="请输入商户纬度" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>		
        <el-form-item label="商户简介" prop="shopInfo">
					<el-input type="textarea" v-model="form.shopInfo"
						placeholder="请输入商户简介" class="inputdis"
						maxlength="300" rows="4" show-word-limit></el-input>
				</el-form-item>	
				<!-- 商户图片 -->
				<el-form-item label="商户图片" prop="shopPhoto" ref="shopPhoto">
					<upload-morefile ref="uploading" :accept='accept' upTypes='1' :fileList='fileListTemp1' :clears='clears'
						@outputFile="getFile1" @removeFile='removeFile1'></upload-morefile>
				</el-form-item>
        <!-- 商户logo -->
        <el-form-item label="商户LOGO" prop="shopLogo" ref="shopPhshopLogooto">
					<upload-morefile ref="uploading" :accept='accept' upTypes='1' :fileList='fileListTemp2' :clears='clears'
						@outputFile="getFile2" @removeFile='removeFile2'></upload-morefile>
				</el-form-item>
				<el-button @click="rest('form')" class="btn-first">{{$t('lang.btn_rest')}}</el-button>
				<el-button type="primary" @click="save('form')" class="detailbtn" :disabled="isDisabled">{{$t('lang.btn_save')}}
				</el-button>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	import uploadmoreFile from '../../../components/upload_morefile.vue'
	import {
		mapGetters
	} from 'vuex'
	export default {
		data() {
      var phone = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7\d|8\d|9\d)\d{8}$/
			var isPhone = (rule, value, callback) => {
				if (value === '') {
					callback(
						new Error('请输入商户电话')
					)
				} else if (!phone.test(value)) {
					callback(
						new Error('请输入正确的手机号')
					)
				} else {
					callback()
				}
			}
			return {
				clears: false, // 清空按钮
				accept: '.jpg, .jpeg, .png',
        gardenList: [], // 项目列表
        houseList: [], // 楼层列表
				isDisabled: true, // 保存的可点击
        gardenId: this.$store.getters.gardenId, // 项目id
				saveData: '', // 存储JSON数据
				editId: '', // 接收编辑页面的参数     
				fileList1: [], // 上传商户图片列表
				fileListTemp1: [], // 上传商户图片列表
        fileList2: [], // 上传商户LOGO列表
				fileListTemp2: [], // 上传商户LOGO列表
        shopType1List: [
					{
						name: '全部',
					},
					{
						name: '创意/生活',
					},
					{
						name: '时尚/潮流',
					},
					{
						name: '主力店',
					},
					{
						name: '童真',
					},
          {
						name: '影院',
					},
          {
						name: '数码电器',
					},
				], // 商户分类列表

				form: {
					gardenId: this.$store.getters.gardenId, // 所在项目
          houseId: '', // 所在楼层
					shopName: '', // 商户名称
					shopNo: '', // 商户编号
					shopType1: '', // 商户分类一级
          shopPhoto: '', // 商户照片
					shopLogo: '', // 商户logo
					shopPhone: '', // 商户电话
					shopInfo: '', // 商户简介
					shopX: '', // 商户经度
					shopY: '', // 商户纬度
				},
				rules: {
          gardenId: [{
						required: true,
						message: '请选择所在项目',
						trigger: 'change'
					}],
          houseId: [{
						required: true,
						message: '请选择所在楼层',
						trigger: 'change'
					}],
					shopName: [{
						required: true,
						message: '请输入商户名称',
						trigger: 'blur'
					}],
          shopNo: [{
						required: true,
						message: '请输入商户编号',
						trigger: 'blur'
					}],
          shopLogo: [{
						required: true,
						message: '请上传商户LOGO',
						trigger: 'change'
					}],
          shopPhoto: [{
						required: true,
						message: '请上传商户照片',
						trigger: 'change'
					}],
          shopPhone: [{
						required: true,
						validator: isPhone,
						trigger: 'blur'
					}],
          shopInfo: [{
						required: true,
						message: '请输入商户简介',
						trigger: 'blur'
					}],
					shopType1: [{
						required: true,
						message: '请选择商户分类',
						trigger: 'change'
					}],
          shopX: [{
						required: true,
						message: '请输入商户经度',
						trigger: 'blur'
					}],
          shopY: [{
						required: true,
						message: '请输入商户纬度',
						trigger: 'blur'
					}],
				},
			}
		},
		components: {
			'upload-morefile': uploadmoreFile
		},
		computed: {
			...mapGetters({
				gardenId: 'gardenId'
			})
		},
		// #8449 add
		destroyed() {
			this.yhStoreManagementForm = {
				form: JSON.stringify(this.form),
				saveData: this.saveData,
				fileList1: JSON.stringify(this.fileList1),
				fileListTemp1: this.fileListTemp1
			}
			window.localStorage.setItem('yhStoreManagementForm', JSON.stringify(this.yhStoreManagementForm))
		},
		created() {
      this.getGardens()
			// add
			if (window.localStorage.getItem('yhStoreManagementForm') && this.$route.query.id == '') {
				let yhStoreManagementForm = JSON.parse(window.localStorage.getItem('yhStoreManagementForm'))
				this.form = JSON.parse(yhStoreManagementForm.form)
				this.saveData = yhStoreManagementForm.saveData
				this.fileList1 = JSON.parse(yhStoreManagementForm.fileList1)
				this.fileListTemp1 = yhStoreManagementForm.fileListTemp1
        this.fileList2 = JSON.parse(yhStoreManagementForm.fileList2)
				this.fileListTemp2 = yhStoreManagementForm.fileListTemp2
			} else {
				// 接收编辑页面参数
				if (this.$route.query.id) {
					this.editId = this.$route.query.id
					this.shopById()
				}
			}
		},
		watch: {
			form: {
				handler(newVal, oldVal) {
					let tempRule = ''
					tempRule = JSON.stringify(newVal)
					if (tempRule === this.saveData) {
						// 没变
						this.isDisabled = true
					} else {
						// 变了
						this.isDisabled = false
					}
				},
				deep: true,
				immediate: true
			},
      gardenId: {
        handler(newVal, oldVal) {
					this.getHouseList()
				},
				deep: true,
				immediate: true
      }
		},
		methods: {
			// 获取商户照片
			getFile1(e) {
				this.fileList1.push({
					name: '',
					url: e
				})
        this.form.shopPhoto = e
				this.isDisabled = false
			},
			// 移除商户照片
			removeFile1(e) {
				this.isDisabled = false
				let list1 = []
				for (let i = 0; i < this.fileList1.length; i++) {
					if (this.fileList1[i] === e || (this.fileList1[i].url && this.fileList1[i].url === e)) {
					} else {
						list1.push(this.fileList1[i])
					}
				}
				this.fileList1 = list1
				this.fileListTemp1 = JSON.parse(JSON.stringify(list1))
				if (list1.length === 0) {
					this.form.shopPhoto = ''
				}
			},
      // 获取商户LOGO
			getFile2(e) {
				this.fileList2.push({
					name: '',
					url: e
				})
        this.form.shopLogo = e
				this.isDisabled = false
			},
			// 移除商户LOGO
			removeFile2(e) {
				this.isDisabled = false
				let list2 = []
				for (let i = 0; i < this.fileList2.length; i++) {
					if (this.fileList2[i] === e || (this.fileList2[i].url && this.fileList2[i].url === e)) {
					} else {
						list2.push(this.fileList2[i])
					}
				}
				this.fileList2 = list2
				this.fileListTemp2 = JSON.parse(JSON.stringify(list2))
				// 如果列表为空，清空表单字段
				if (list2.length === 0) {
					this.form.shopLogo = ''
				}
			},
      // 获取小区列表
      getGardens() {
				let loading = this.$loading()
				this.$get(`/gardens`).then(res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.gardenList = res.list
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					})
			},
      // 获取楼层列表
      getHouseList() {
        let loading = this.$loading()
				this.$get(`/gardenGrids?gardenGridsName=&type=1&isShop=1&parentId=${this.gardenId}&pageNo=1&pageSize=999`).then(res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.houseList = res.list
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					})
      },
			// 返回列表页
			back() {
				this.$router.push({
					name: 'yhStoreManageList'
				})
			},
      // 详情
			shopById() {
				let loading = this.$loading()
				this.$get(`/gardenShop/` + this.editId).then(res => {
						console.log(res)
						loading.close()
						if (res && res.errCode === 0) {
							this.form = res.data
							this.fileList1 = []
							if (res.data.shopPhoto) {
									this.fileList1.push({
										name: '',
										url: res.data.shopPhoto
									})
							}
							this.fileListTemp1 = JSON.parse(JSON.stringify(this.fileList1))
              this.fileList2 = []
							if (res.data.shopLogo) {
									this.fileList2.push({
										name: '',
										url: res.data.shopLogo
									})
							}
							this.fileListTemp2 = JSON.parse(JSON.stringify(this.fileList2))
							this.saveData = JSON.stringify(this.form)
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					})
			},
      // 保存
			save(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						if (this.fileList1.length > 0) {
							this.form.shopPhoto = this.fileList1[0].url
						}
						if (this.fileList2.length > 0) {
							this.form.shopLogo = this.fileList2[0].url
						}
						if (this.editId === '') {
							let loading = this.$loading()
							let params = {
								gardenId: this.form.gardenId,
                houseId: this.form.houseId,
                shopName: this.form.shopName,
                shopNo: this.form.shopNo,
                shopType1: this.form.shopType1,
                shopPhoto: this.form.shopPhoto,
                shopLogo: this.form.shopLogo,
                shopPhone: this.form.shopPhone,
                shopInfo: this.form.shopInfo,
                shopX: this.form.shopX,
                shopY: this.form.shopY,
							}
              console.log(params)
							this.$post(`/gardenShop`, params).then(
								res => {
									loading.close()
									if (res && res.errCode === 0) {
										this.$message.success(this.$i18n.t('lang.lab_save_success'))
										this.back()
									} else {
                    loading.close()
                    this.$message.error(res.errMsg)
                  }
								},
								error => {
									loading.close()
									this.$message.error(error)
								}
							)
						} else {
							let loading = this.$loading()
							let params = {
								gardenId: this.form.gardenId,
                houseId: this.form.houseId,
                shopName: this.form.shopName,
                shopNo: this.form.shopNo,
                shopType1: this.form.shopType1,
                shopPhoto: this.form.shopPhoto,
                shopLogo: this.form.shopLogo,
                shopPhone: this.form.shopPhone,
                shopInfo: this.form.shopInfo,
                shopX: this.form.shopX,
                shopY: this.form.shopY,
							}
							this.$patch(`/gardenShop/${this.editId}`, params).then(
								res => {
									loading.close()
									if (res && res.errCode === 0) {
										this.$message.success(this.$i18n.t('lang.lab_save_success'))
										this.back()
									} else {
                    loading.close()
                    this.$message.error(res.errMsg)
                  }
								},
								error => {
									loading.close()
									this.$message.error(error)
								}
							)
						}
					}
				})
			},
      // 清空
			rest(form) {
				this.clears = true
				this.$refs.form.clearValidate()
				this.form.gardenId = this.$store.getters.gardenId
        this.form.houseId = ''
        this.form.shopName = ''
        this.form.shopNo = ''
        this.form.shopType1 = ''
        this.form.shopLogo = ''
        this.form.shopPhoto = ''
        this.form.shopPhone = ''
        this.form.shopInfo = ''
        this.form.shopX = ''
        this.form.shopY = ''
			},
		}
	}
</script>

<style lang='scss'>
	.yhStoreManageAdd {
		// 调整输入框和选择框的宽度一致
		.inputdis {
			width: 30vw;
		}
		.selGard {
			width: 30vw;
		}
	}
</style>